import React, { useEffect } from 'react';
import {
  TableRow, TableCell, ListItem, ListItemText
} from '@material-ui/core';
import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { MUISelect, ValidatorForm } from 'components/FormHelpers/FormInputs';
import _ from 'lodash';
import {
  getUIDateFormat, useCtxParseValue, getEmptyValue
} from 'helpers';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';
import { compose } from 'recompose';
import { SiteSelector } from 'containers/protocol/components';
import { withChangeHandlers } from 'helpers/Change';


export const OrgType = ({
  orgType, handleChange
}) => {
  const { protocolPartiOrgType } = useCtxParseValue('LOV_PARTICPATION_ORG_TYPE');
  return (
    <MUISelect
      title="Org Type"
      value={getEmptyValue(orgType)}
      name="orgType"
      onChange={handleChange}
      validators={['required']}
      errorMessages={['Required Field']}
    >
      {_.map(protocolPartiOrgType, (item, i) => (
        <ListItem
          button
          key={_.uniqueId('parti_orgtype_sel')}
          value={item.enum_string}
        >
          <ListItemText primary={item.meaning} />
        </ListItem>
      ))}
    </MUISelect>

  );
};


export const ParticipantSite = ({
  participantGroup, handleChange, orgType
}) => (
  <SiteSelector
    name="participantGroup"
    onChanged={handleChange}
    orgTypeExp="^(ITN|CCR|CLC)$"
    validators={['required']}
    errorMessages={['Required Field']}
    selSite={participantGroup}
  />
);

export const ParticipantGroup = ({
  participantGroup, handleChange, orgType
}) => {
  const { protocolParticipant } = useCtxParseValue('LOV_PARTICPATION_PARTICIPANT');
  const grouplov = protocolParticipant && orgType
  && _.filter(protocolParticipant, (o) => o.ogn_type === orgType);
  const participantGrpLov = grouplov && grouplov[0] && JSON.parse(grouplov[0].ctep_id);

  return (
    <MUISelect
      title="Participant Group"
      validators={['required']}
      errorMessages={['Required Field']}
      value={getEmptyValue(participantGroup)}
      name="participantGroup"
      onChange={handleChange}
    >
      {_.map(participantGrpLov, (item, i) => (
        <ListItem
          button
          key={_.uniqueId('parti_participant_grp_sel')}
          value={item}
        >
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </MUISelect>
  );
};


export const Role = ({ roleType, orgType, handleChange }) => {
  const { protocolParticipantRoleType } = useCtxParseValue('LOV_PARTICIPANT_ROLE_TYPE');
  const rv = protocolParticipantRoleType && orgType
  && _.filter(protocolParticipantRoleType, (o) => JSON.parse(o.ogn_type).includes(orgType));
  const roleTypeLov = rv && rv[0] && JSON.parse(rv[0].role_type);
  return (
    <MUISelect
      title="Role"
      value={getEmptyValue(roleType)}
      name="roleType"
      onChange={handleChange}
    >
      {_.map(roleTypeLov, (item, i) => (
        <ListItem
          button
          key={_.uniqueId('parti_roleType_sel')}
          value={item}
        >
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </MUISelect>
  );
};

export const ParticipantType = ({
  participationType, handleChange
}) => {
  const { protocolPartiType } = useCtxParseValue('LOV_PARTICIPANT_TYPE');
  return (
    <MUISelect
      // defaultValue={state.orgType}
      title="Participant Type"
      value={getEmptyValue(participationType)}
      name="participationType"
      onChange={handleChange}
    >
      {protocolPartiType && _.map(protocolPartiType, (item, i) => (
        <ListItem
          button
          key={_.uniqueId('parti_partiType_sel')}
          value={item}
        >
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </MUISelect>

  );
};


export const StartDate = ({
  startDate, handleDateChange, endDate
}) => {
  useEffect(() => {
    ValidatorForm.addValidationRule('startDateValidation', value => {
      if (!endDate) {
        return true;
      }
      return value
      && value < getUIDateFormat(endDate);
    }, [startDate, endDate]);
  });
  return (
    <MUIDatePicker
      title="Start Date"
      name="startDate"
      onChange={handleDateChange('startDate')}
      validators={['startDateValidation']}
      value={startDate ? getUIDateFormat(startDate) : ''}
      errorMessages={[`Start date should not be greater than ${endDate}`]}
    />
  );
};


export const EndDate = ({
  endDate, handleDateChange
}) => (
  <MUIDatePicker
    title="End Date"
    name="endDate"
    onChange={handleDateChange('endDate')}
    value={endDate ? getUIDateFormat(endDate) : ''}
  />
);

export const Source = ({ source }) => (<>{source || 'RSS'}</>);

export const Restriction = ({ hasRestrictions, handleChange }) => (
  <MUISelect
    value={hasRestrictions === true}
    name="hasRestrictions"
    onChange={handleChange}
    title="Restriction"
  >
    <ListItem button value>
      <ListItemText primary="Yes" />
    </ListItem>
    <ListItem button value={false} default>
      <ListItemText primary="No" />
    </ListItem>
  </MUISelect>
);


const Editparticipation = (props) => {
  const {
    cancel,
    reset,
    state,
    handleDateChange,
    handleSiteChange,
    handleChange
  } = props;

  const {
    orgType,
    participantGroup,
    roleType,
    participationType,
    startDate,
    endDate,
    hasRestrictions,
    dataSource,
    esysStatus
  } = state || {};

  return (
    <TableRow>
      <TableCell>
        <OrgType
          orgType={orgType}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell className="disableOverflow">
        {
          state && state.orgType && (
            ['ETCTN', 'LAPS', 'NCORP', 'NCTN', 'OTHER NETWORK', 'CCC'].includes(orgType)
              ? (
                <ParticipantGroup
                  orgType={orgType}
                  participantGroup={participantGroup}
                  handleChange={handleChange}
                />
              )
              : (
                <ParticipantSite
                  handleChange={handleSiteChange}
                  participantGroup={participantGroup}
                  orgType={orgType}
                />
              )
          )
        }
      </TableCell>
      <TableCell>
        <Role
          roleType={roleType}
          orgType={orgType === 'ITN' ? 'SITE' : orgType}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <ParticipantType
          participationType={participationType}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <StartDate
          startDate={startDate}
          endDate={endDate}
          handleDateChange={handleDateChange}
        />
      </TableCell>
      <TableCell>
        <EndDate
          endDate={endDate}
          handleDateChange={handleDateChange}
        />
      </TableCell>
      <TableCell>
        <Source
          source={dataSource}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        {esysStatus}
      </TableCell>
      <TableCell>
        <Restriction
          hasRestrictions={hasRestrictions}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell align='center'>
        <GridSubmitAction
          cancel={cancel}
          reset={reset}
        />
      </TableCell>
    </TableRow>
  );
};


const EditParticipation = compose(withChangeHandlers)(Editparticipation);

export default EditParticipation;
